export enum DictCodeEnmu {
    //车辆品牌
    VEHICLE_BRAND = 'vehicle-brand',
    //车辆类型
    VEHICLE_TYPE = 'vehicle-type',
    //物资管理类型
    TCO_TYPE = "tco-type",
    //物资管理类型
    BILL_METHOD = "bill-method",
    //组织机构
    ORG = "cm-organization",
    //订单来源
    ASSETS_SOURCE = "assets-source",
    //资产分类
    ASSETS_TYPE = "assets-type",
    //物资单据状态
    ASSETS_STATUS = "assets-status",
    //报废类型
    ASSETS_DISCARD = "assets-discard",
    //物资单据类型
    ASSETS = "assets",
    //领取类型
    RECEIVE_TYPE = "receive-type",
    //物资单位
    ASSETS_UNIT = "assets-unit",
    //物资类型
    ASSETS_MATERIAL_TYPE = "assets-material-type",
    //物资发票状态
    ASSETS_INVOICE_STATUS = "assets-invoice-status",
    //物资发票类型
    ASSETS_INVOICE_TYPE = "assets-invoice-type",
    //归还类型
    ASSETS_RETURN_TYPE = "assets-return-type",
    //盘点类型
    ASSETS_TRANSFER_TYPE = "assets-transfer-type",
    //盘点单状态
    ASSETS_STOCKTAKING = 'assets-stocktaking-status',
    // 盘点单状态(已完成)
    ASSETS_STOCKTAKING_COMPLETE = 'assets-stocktaking.complete',
    // 盘点单状态(已审核)
    ASSETS_STOCKTAKING_AUDIT = 'assets-stocktaking.audit',
    // 盘库单状态(进行中)
    ASSETS_STOCKTAKING_CREATE = 'assets-stocktaking.create',
    // 盘库单状态(已作废)
    ASSETS_STOCKTAKING_CHANGE = 'assets-stocktaking.change',
    // 采购类型
    ASSETS_PROCURE = 'assets-procure',
    // 转移类型
    ASSETS_TRANSFER = 'assets-transfer',
    // 申请类型
    ASSETS_APPLY_TYPE = 'assets-apply-type',
    // 申请状态
    ASSETS_APPLY_STATUS = 'assets-apply-status',
}
export const sourceAppOrBranch = {
    sourceApp: 'assets',
    branch: 'assets',
}